import { useTranslate } from "ra-core";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { BooleanInput } from "@/components/admin/boolean-input";
import { NumberInput } from "@/components/admin/number-input";
import { SelectInput } from "@/components/admin/select-input";
import { Card, CardContent } from "@/components/ui/card";

import { useTags } from "../tags/useTags";

/** Settings → Dashboard: what the owner's numbers count and which blocks show */
export const SettingsDashboard = () => {
  const translate = useTranslate();
  const { data: tags = [] } = useTags();
  const t = (key: string) => translate(`crm.settings.dashboard.${key}`);
  // Never chosen yet: the dashboard already uses «Старий лід», show it here too
  const { getValues, setValue } = useFormContext();
  useEffect(() => {
    const old = tags.find((tag) => tag.name === "Старий лід");
    if (getValues("dashboard.oldTagId") === undefined && old)
      setValue("dashboard.oldTagId", old.id, { shouldDirty: false });
  }, [tags, getValues, setValue]);
  return (
    <Card>
      <CardContent className="space-y-6">
        <h2 className="text-xl font-semibold text-muted-foreground">
          {t("title")}
        </h2>
        <section className="grid gap-4 md:grid-cols-2">
          <SelectInput
            source="dashboard.oldTagId"
            label={t("old_tag")}
            helperText={t("old_tag_hint")}
            choices={tags.map((tag) => ({ id: tag.id, name: tag.name }))}
            emptyText={t("old_tag_none")}
          />
          <SelectInput
            source="dashboard.defaultPeriod"
            label={t("default_period")}
            helperText={false}
            choices={(["week", "month", "all"] as const).map((id) => ({
              id,
              name: translate(`crm.owner_dashboard.periods.${id}`),
            }))}
          />
          <NumberInput
            source="dashboard.fastMinutes"
            label={t("fast_minutes")}
            helperText={t("fast_minutes_hint")}
            min={1}
            max={240}
          />
          <NumberInput
            source="dashboard.bookingDays"
            label={t("booking_days")}
            helperText={t("booking_days_hint")}
            min={1}
            max={30}
          />
        </section>
        <section className="space-y-2">
          <h3 className="font-semibold">{t("blocks")}</h3>
          {(
            [
              "showDaily",
              "showAttention",
              "showApartments",
              "showManagers",
            ] as const
          ).map((key) => (
            <BooleanInput
              key={key}
              source={`dashboard.${key}`}
              label={t(key)}
              helperText={false}
            />
          ))}
        </section>
      </CardContent>
    </Card>
  );
};
